import Vue from 'vue'
import Router from 'vue-router'
import Room from '@/components/Room'
import Media from '@/components/Media'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/room/:roomId',
      name: 'Room',
      component: Room,
      props: true
    },
    {
      path: '/media/:roomId',
      name: 'Media',
      component: Media,
      props: true
    }
  ]
})



// WEBPACK FOOTER //
// ./client/router/index.js